import React, {Component} from 'react';
import * as actions from '../../../actions';
import {Form, Icon, Input, Button, Alert} from 'antd';

const FormItem = Form.Item;

const logo = process.env.PUBLIC_URL + '/assets/logo/logo_dvs.png';

export class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checkUser: false,
            username: "",
            password: "",
            errors: ""
        };
        this.handleCheckUser = this.handleCheckUser.bind(this);
    }

    async handleCheckUser({username, password}) {
        const user = {
            login: username,
            password: password
        };

        await this.props.dispatch(actions.getLogin(user, true));
        await this.props.dispatch(actions.login(user));
    }

    componentDidMount() {
        let {token, history} = this.props;
        if (token !== "") {
            history.push('/');
        }
    }

    componentWillUpdate(nextProps, nextState) {
        let {token} = nextProps;
        let {history} = nextProps;
        if (token !== "") {
            history.push('/');
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.errors && nextProps.errors.length !== '') {
            this.setState({errors: nextProps.errors});
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, loginInfo) => {
            if (!err) {
                this.handleCheckUser(loginInfo);
            }
        });
    };

    render() {
        const {getFieldDecorator} = this.props.form;

        return (
            <Form onSubmit={this.handleSubmit} className="login-form">
                <FormItem>
                    <img
                        style={{position:'relative',left:'30px'}}
                        alt="dinhviso"
                         width="235px"
                         src={logo}/>
                </FormItem>
                <FormItem style={{
                    marginTop: '30px'
                }}>
                    {getFieldDecorator('username', {
                        rules: [{required: true, message: 'Tên đăng nhập không được để trống!'}],
                    })(
                        <Input
                            size={'large'}
                            prefix={<Icon type="user" style={{fontSize: 13}}/>}
                            placeholder="Tên đăng nhập"/>
                    )}
                </FormItem>
                <FormItem style={{top: '10px'}}>
                    {getFieldDecorator('password', {
                        rules: [{required: true, message: 'Mật khẩu không được để trống!'}],
                    })(
                        <Input
                            size={'large'}
                            prefix={<Icon type="lock" style={{fontSize: 13}}/>}
                            type="password"
                            placeholder="Mật khẩu"/>
                    )}
                </FormItem>
                <FormItem style={{top: '15px'}}>
                    <Button
                        size={'large'}
                        type="primary"
                        htmlType="submit"
                        className="login-form-button">
                        Đăng Nhập
                    </Button>
                </FormItem>
                {
                    this.state.errors.length > 0 ?
                        <FormItem>
                            <Alert type="error" message={this.state.errors} banner/>
                        </FormItem>
                        : null
                }

            </Form>
        );
    }
}

export default Form.create()(Login);


// WEBPACK FOOTER //
// ./src/components/users/auth/login.js